var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.00585938C10.21 0.00585938 12 1.79586 12 4.00586C12 6.21586 10.21 8.00586 8 8.00586C5.79 8.00586 4 6.21586 4 4.00586C4 1.79586 5.79 0.00585938 8 0.00585938ZM8 2.00586C6.9 2.00586 6 2.90586 6 4.00586C6 5.10586 6.9 6.00586 8 6.00586C9.1 6.00586 10 5.11586 10 4.00586C10 2.89586 9.11 2.00586 8 2.00586ZM8 9.00586C10.67 9.00586 16 10.3359 16 13.0059V16.0059H0V13.0059C0 10.3359 5.33 9.00586 8 9.00586ZM8 10.9059C5.03 10.9059 1.9 12.3659 1.9 13.0059V14.1059H14.1V13.0059C14.1 12.3659 10.97 10.9059 8 10.9059ZM9 18.0059H7V20.0059H9V18.0059ZM13 18.0059H11V20.0059H13V18.0059ZM5 18.0059H3V20.0059H5V18.0059Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.545722e8.svg";
export { ForwardRef as ReactComponent };